/* eslint-disable no-extend-native */
declare global {
  export interface String {
    toReadableAmount(): string,
    toCapitalizeFormat(): string,
    trimAbove(length : number) : string,
    toBKAccountFormat() : string,
    isEmpty() : boolean,
  }
}

String.prototype.toReadableAmount = function (): string {
  const target = String(this)
  return target.split('.')[1]
    ? target.split('.')[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
        `.${target.split('.')[1]}`.slice(0, 3)
    : target.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export const parseFormattedAmount = (
  amount: string | number | null | undefined,
): number => {
  if (typeof amount === 'number') return amount
  if (amount === null || amount === undefined) return NaN
  const cleaned = String(amount).replace(/,/g, '').trim()
  if (cleaned === '') return NaN
  return Number(cleaned)
}

export const capitalizeFirstLetter = (name: string) => {
  let newString
  if (typeof name === 'string')
    newString = name?.charAt(0).toUpperCase() + name?.slice(1).toLowerCase()
  return newString
}

export const nameFormat = (name: string) => {
  let fullName
  fullName =
    capitalizeFirstLetter(name?.split(' ')[0]) +
    ' ' +
    `${
      name?.split(' ').length > 2
        ? name.split(' ')[1]?.charAt(0).toUpperCase() +
          '.' +
          ' ' +
          name.split(' ')[2]?.toUpperCase()
        : name.split(' ')[1]?.toUpperCase() || ''
    }`
  return fullName
}

String.prototype.toCapitalizeFormat = function (): string {
  let words = String(this)?.toLowerCase()?.split(' ')
  for (let i = 0; i < words.length; i++) {
    words[i] = words[i].charAt(0).toUpperCase() + words[i].substring(1)
  }
  return words.join(' ')
}

String.prototype.trimAbove = function (length : number) : string {
  let target = this as string
  if (target.length > length) {
    target = target.slice(0, length) + '...'
  }
  return target
}

String.prototype.toBKAccountFormat = function () : string {
  const target = this.trim()
  if (target.length >= 16) {
    return `${target.substring(0, 5)}-${target.substring(5, 13)}-${target.substring(13, 16)}`
  }
  else if(target.length >= 15){
    return `${target.substring(0, 5)}-${target.substring(5, 13)}-${target.substring(13, 15)}`
  } 
  else if (target.length > 13 && target.length < 15) {
    return `${target.substring(0, 5)}-${target.substring(5, 13)}-${target.substring(13, 14)}`
  } else if (target.length > 5) {
    return `${target.substring(0, 5)}-${target.substring(5)}`
  } else {
    return target
  }
}

String.prototype.isEmpty = function () : boolean {
  let target = this as string
  return target.length === 0 || target === null || target === 'null' || target === undefined
}

export {}
